import { Box, Grid, Stack, Switch, Typography } from '@mui/material';
import React from 'react'
import InputForm from '../../../../../../components/forms/InputForm';
import DoctorChatPrices from './DoctorChatPrices';

const DoctorChat = ({
    chat_available,
    onChangeChatStatus,
    form,
    onChange
}) => {
    return ( 
        <>
            <Box sx={{mt:3}}>
                <Typography variant='subtitle1' sx={{mb:2}}>Chat privado</Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <InputForm data={form.private_chat_reference_code} onChange={onChange}  />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InputForm data={form.license} onChange={onChange}  />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <DoctorChatPrices />
                    </Grid>
                </Grid>
            </Box>
        </>
     );
}
 
export default DoctorChat;